document.querySelectorAll( '.problem-section__video-wrapper' ).forEach( ( wrapper ) => {
	const video = wrapper.querySelector( '.problem-section__video' );
	const btn   = wrapper.querySelector( '.problem-section__play-btn' );
	if ( ! video || ! btn ) return;

	btn.addEventListener( 'click', () => {
		// If video has a poster attribute, remove it once playing so it doesn't flash on replay.
		if ( video.hasAttribute( 'poster' ) ) {
			video.removeAttribute( 'poster' );
		}
		video.controls = true;
		video.play().catch( () => {} );
		wrapper.classList.add( 'is-playing' );
	} );

	video.addEventListener( 'pause', () => {
		wrapper.classList.remove( 'is-playing' );
	} );

	video.addEventListener( 'ended', () => {
		wrapper.classList.remove( 'is-playing' );
	} );
} );
